import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Event Gallery', path: '/event-gallery' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen ? 'bg-white shadow-lg' : 'bg-white/90'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/0890122b367f23c3338a761be89943be/dcdc3ad3223627cc9233b520af264f75.png"
              alt="Lemonade Coffee Store"
              className="h-14 w-auto"
            />
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-semibold transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-[#FFD700]'
                    : 'text-[#2C5F2D] hover:text-[#FFD700]'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Hamburger button (mobile only) */}
          <button
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg text-[#2C5F2D] cursor-pointer"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#2C5F2D]/10 px-4 pb-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block py-3 text-base font-semibold border-b border-[#2C5F2D]/10 last:border-0 cursor-pointer whitespace-nowrap ${
                location.pathname === link.path
                  ? 'text-[#FFD700]'
                  : 'text-[#2C5F2D] hover:text-[#FFD700]'
              }`}
            >
              {link.name}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
